module.exports = __webpack_public_path__ + "static/img/icon11.7a5d893.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icon11.jpg
// module id = Erex
// module chunks = 16